import React from "react";

import { useHistory } from "react-router-dom";

import { Spinner } from "react-bootstrap";
import ReactPaginate from "react-paginate";

import {
  GridStyled,
  Wrapper,
  Itemheader,
  HeaderStyled,
  BodyTableStyled,
  CelTable,
  RowTable,
  PaginateStyled,
} from "./styled";
import { theme } from "../../styles/theme";

import { settings } from "../../../main/configs/settings";

export type ItemField = {
  title: string;
  key: string;
  size?: number;
  renderItem: (callback: any) => any;
  hide?: boolean;
};

export type DatgridProps = {
  routeToEdit?: string;
  fields: ItemField[];
  data: any[];
  changePage?: (ev: any) => void;
  onClickRow?: (ev: any) => void;
  totalPages: number;
  loading: boolean;
  shouldForcePage?: boolean;
};

const DataGrid: React.FC<DatgridProps> = ({
  fields,
  data,
  changePage,
  routeToEdit,
  totalPages,
  loading,
  onClickRow,
  shouldForcePage,
}) => {
  const history = useHistory();

  const handlePageClick = (event: any): void => {
    if (changePage) changePage(event.selected);
  };

  const goToEdit = (id: number): void => {
    if (routeToEdit) history.push(`${routeToEdit}${id}`);
  };

  return (
    <Wrapper className="data-grid">
      <GridStyled>
        <HeaderStyled className="header-grid">
          {fields
            .filter((field) => !field.hide)
            .map((field) => (
              <Itemheader key={field.key}>{field.title}</Itemheader>
            ))}
        </HeaderStyled>
        {loading ? (
          <Spinner
            animation="grow"
            style={{ margin: "0 auto" }}
            variant="primary"
          />
        ) : (
          <BodyTableStyled className="body-grid">
            {data.map((item, index) => (
              <RowTable
                className="row-grid"
                key={item.id}
                style={{
                  color:
                    item.status === "CANCELED" ? theme.colors.red : "white",
                }}
                index={index}
                onClick={() => {
                  if (onClickRow) onClickRow(item);
                  if (routeToEdit) goToEdit(item.id);
                }}
              >
                {fields
                  .filter((field) => !field.hide)
                  .map((field) => {
                    const cellContent = field.renderItem(item);
                    if (
                      typeof cellContent === "string" ||
                      typeof cellContent === "number"
                    ) {
                      return (
                        <CelTable className="cel-grid" key={field.key}>
                          {cellContent}
                        </CelTable>
                      );
                    }
                    return (
                      <CelTable className="cel-grid" key={field.key}>
                        {cellContent}
                      </CelTable>
                    );
                  })}
              </RowTable>
            ))}
          </BodyTableStyled>
        )}
        <PaginateStyled className="paginate">
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            onPageChange={handlePageClick}
            pageRangeDisplayed={settings.perPage}
            pageCount={totalPages}
            previousLabel="<"
            nextClassName="next-button"
            prevClassName="prev-button"
            forcePage={shouldForcePage ? 0 : undefined}
          />
        </PaginateStyled>
      </GridStyled>
    </Wrapper>
  );
};

export default DataGrid;
